/* eslint-disable consistent-return */

import { GRID_BREAKPOINT_MEDIUM, IS_DEVELOPMENT } from '../constants/constants';

export const toggleAttribute = (el, attr) => {
    el.attr(attr) === 'true'
        ? el.attr(attr, 'false')
        : el.attr(attr, 'true');
};

export const isMobileScreen = () => {
    return window.innerWidth <= GRID_BREAKPOINT_MEDIUM;
};

export const isMobileDevice = () => {
    return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
        && window.innerWidth <= GRID_BREAKPOINT_MEDIUM)
};

export const throttle = (fn, wait) =>  {
    var time = Date.now();
    return function() {
        if ((time + wait - Date.now()) < 0) {
            fn();
            time = Date.now();
        }
    }
}
